// Platform role IDs (CSV order): Superadmin 1, Admin 2, Administration Admin 3,
// Administration User 4, Moderator 5, User (cetățean) 6.
export const USER_ROLE_IDS = {
	superadmin: 1,
	admin: 2,
	administrationAdmin: 3,
	administration: 4,
	moderator: 5,
	user: 6
} as const;

// Eticheta de AFIȘARE a unui rol: BE trimite acum `label` (localizat, ex. „Administrator")
// pe lângă `name` (identificatorul intern, ex. „Admin"). Peste tot unde arătăm rolul în UI
// folosim label, cu fallback pe name (inclusiv când label vine gol). Identitatea / logica de
// rol rămân pe `name`/`id`, niciodată pe label.
export const roleLabel = (
	role?: { name?: string | null; label?: string | null } | null
): string => role?.label || role?.name || '';

// Avatarul din BE poate veni ca URL simplu (istoric) sau ca obiect de asset
// ({ id, fileName, publicUrl } — forma actuală din users/me). Peste tot unde se
// AFIȘEAZĂ avatarul folosim helperul, nu câmpul brut.
export type AvatarRef =
	| string
	| { id?: number; fileName?: string; publicUrl?: string | null; url?: string | null }
	| null
	| undefined;

export const avatarUrlOf = (avatar: AvatarRef): string | undefined =>
	typeof avatar === 'string'
		? avatar || undefined
		: avatar?.publicUrl || avatar?.url || undefined;

// Id-ul assetului de avatar (doar forma-obiect îl are) — necesar la înlocuire, ca
// avatarul VECHI să fie șters din bucket după un update reușit.
export const avatarIdOf = (avatar: AvatarRef): number | undefined =>
	avatar && typeof avatar === 'object' && typeof avatar.id === 'number'
		? avatar.id
		: undefined;

// Rolurile vizibile ca taburi în „Conturi interne" (și în dropdown-ul din meniul lateral),
// în funcție de rolul celui logat. Cetățenii (roleId user) au interfață dedicată, iar
// moderatorii au secțiune proprie (grupul Organizație) — filtrați de apelanți.
export const getViewableRoleIds = (
	viewerRole: string | undefined,
	availableRoleIds: number[]
): number[] => {
	if (viewerRole === 'superadmin') {
		// Superadminul își vede și tabul de Superadmini (creează/editează alți superadmini);
		// doar cetățenii (rol user) au interfață dedicată și sunt excluși.
		return availableRoleIds.filter((roleId) => roleId !== USER_ROLE_IDS.user);
	}

	if (viewerRole === 'admin') {
		// Adminul vede tabul Administratori (conturi de platformă). Moderatorii au secțiune
		// dedicată, iar administrațiile/cetățenii nu-i sunt în grija din „Conturi interne".
		return availableRoleIds.filter((roleId) => roleId === USER_ROLE_IDS.admin);
	}

	// Rolurile de administrație (fsp) și restul nu au acces la „Conturi interne".
	return [];
};

// Rolurile pe care le poate CREA utilizatorul logat (folosit la pagina de creare și la
// gating-ul butonului „Adaugă" din listă). Separat de vizibilitate: adminul VEDE conturile
// de administrator, dar nu creează alți administratori (doar superadminul poate).
export const getCreateRoleIds = (
	viewerRole: string | undefined,
	availableRoleIds: number[]
): number[] => {
	if (viewerRole === 'superadmin') {
		// Doar superadminul poate crea alți superadmini → rolul Superadmin rămâne în listă.
		return availableRoleIds.filter((roleId) => roleId !== USER_ROLE_IDS.user);
	}

	if (viewerRole === 'admin') {
		return availableRoleIds.filter((roleId) => roleId === USER_ROLE_IDS.moderator);
	}

	return [];
};
